<template>
<div>
    <section class="masthead">
        <div class="ui stackable grid">
            <div class="eight wide column">
                <h1 class="display">
                    Welcome to your Home Inventory.
                </h1>
                <p class="display" v-if="!user">Take photos, set prices, declutter.</p>
                <p class="display" v-if="user">Check out this video while we set up your account. Any hiccups during account setup are natural and automatic but they should pass (fingers crossed).</p>
                <div v-if="!user">
                    <router-link to="/login" class="ui primary big button">Login / Register <i title="welcome" class="sign-in icon"></i></router-link>
                </div>
                <div v-if="user">
                    <router-link to="/capture" class="ui primary big button"><i title="welcome" class="camera retro icon"></i> Take Photos</router-link>
                    <router-link to="/items" class="ui secondary cta"><i title="welcome" class="boxes icon"></i> Organize Stuff</router-link>
                </div>
            </div>
            <div class="eight wide column">
                <div style="position: relative; padding-bottom: 56.25%; height: 0;"><iframe src="https://www.loom.com/embed/4420e69322b4405f9f73fdee3d049118" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>
            </div>
        </div>
    </section>
    <section>
        <div class="ui column grid">
            <div class="column">
                <h2 class="ui centered aligned header">
                    Why should you use this app?
                </h2>
            </div>
        </div>
        <div class="ui three column stackable grid">
            <div class="column blurb">
            <div class="ui segment">
                <i class="camera retro huge icon"></i>
                <div class="blurb-title">Take Photos</div>
                <p class="blurb-content">Catalogue your stuff with multiple photos, descriptions and labels</p>
            </div>
            </div>
            <div class="column blurb">
            <div class="ui segment">
                <i class="balance scales huge icon"></i>
                <div class="blurb-title">Set Values</div>
                <p class="blurb-content">Set a price on items for insurance or to identify your stuffs total worth</p>
            </div>
            </div>
            <div class="column blurb">
            <div class="ui segment">
                <i class="trash huge icon alternate"></i>
                <div class="blurb-title">Declutter</div>
                <p class="blurb-content">Tag your stuff Keep, Sell, or Donate to improve your feng shui</p>
            </div>
            </div>
            <div class="column blurb">
            <div class="ui segment">
                <i class="microchip huge icon"></i>
                <div class="blurb-title">ML-based Scanning</div>
                <p class="blurb-content">Scan your photos to identify their contents and capture text</p>
            </div>
            </div>
            <div class="column blurb">
            <div class="ui segment">
                <i class="share square huge icon"></i>
                <div class="blurb-title">Collaborate</div>
                <p class="blurb-content">Easily share your account with a partner who has their own account</p>
            </div>
            </div>
            <div class="column blurb">
            <div class="ui segment">
                <i class="child huge icon"></i>
                <div class="blurb-title">You are not the product</div>
                <p class="blurb-content">We don't charge you anything and don't sell your data.</p>
            </div>
            </div>
        </div>
    </section>
    <section>
        <div class="ui column grid">
            <div class="column">
                <h2 class="ui centered aligned header">
                    How should you use this app?
                </h2>
            </div>
        </div>
        <div class="ui three column stackable grid">
            <div class="column blurb">
            <div class="ui segment">
                <i class="paper plane huge icon"></i>
                <div class="blurb-title">1. Catalog everything</div>
                <p class="blurb-content">Set aside an hour and use the app from your phone. Take photos of every possession to make a record of it. Take photos of serial numbers and barcodes to save yourself time later.</p>
            </div>
            </div>
            <div class="column blurb">
            <div class="ui segment">
                <i class="car huge icon"></i>
                <div class="blurb-title">2. Get organized</div>
                <p class="blurb-content">Next step is to go through "Your Stuff" and mark things as sell, keep or donate. Set descriptions with handy reminders or warranty info. Get help from your partner or a friend to vote stuff out of your home.</p>
            </div>
            </div>
            <div class="column blurb">
            <div class="ui segment">
                <i class="rocket icon huge"></i>
                <div class="blurb-title">3. List items online</div>
                <p class="blurb-content">Now that you know what you want to get rid of You can easily drag and drop your saved items from the app to any marketplace. Copy+paste descriptions, list items and declutter.</p>
            </div>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import * as firebase from 'firebase'
export default {
  name: 'Welcome',
  components: {
  },
    data() {
        return {
          user: false,
          isAnonymous: false,
          accountClaimed: false
        };
    },
    mounted() {
      this.user = firebase.auth().currentUser
      if (this.user && firebase.auth().currentUser.isAnonymous && !this.user.email) {
        this.isAnonymous = true
      }
    }
}
</script>

<style>
    #app.hasFixedMenu {padding-top: 54px;}
    section {
        padding: 60px 0 0;
    }

    .masthead h1 {
        font-size: 3em;
        margin-bottom: 15px;
    }

    .masthead p {
        font-size: 1.5em;
        margin-bottom: 60px;
    }

    .secondary.cta {
        display: inline-block;
        margin-left: 15px;
        font-size: 18px;
    }

    .blurb {
        text-align: center;
    }

    .blurb .ui.segment {
        padding: 30px 0;
    }

    .blurb .blurb-title {
        font-weight: bold;
        font-size: 1.5em;
        margin: 15px 0;
    }

    .blurb .blurb-content {
        font-size: 1.2em;
        max-width: 70%;
        margin: 0 auto;
    }

    @media (max-width: 768px) {
        .masthead {
            padding-top: 15px;
        }
        .masthead h1 {
            font-size: 2.5em;
        }
        .masthead p {
            margin-bottom: 30px;
        }
        
        .cta {
            margin: 30px 0;
        }
    }
</style>